// import { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   HiPhone,
//   HiLocationMarker,
//   HiChevronUp,
//   HiChevronDown,
// } from "react-icons/hi";
// import {
//   FaFacebookF,
//   FaTwitter,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
// } from "react-icons/fa";
// import { motion, AnimatePresence } from "framer-motion";
// import logo from "../../Assets/Logos/insd-logo.png";

// const UserFooter = () => {
//   const [openSection, setOpenSection] = useState(null);
//   const currentYear = new Date().getFullYear();

//   const toggleSection = (section) => {
//     setOpenSection(openSection === section ? null : section);
//   };

//   const footerSections = {
//     quickLinks: [
//       { name: "Gallery", path: "/gallery" },
//       { name: "Blog & News", path: "/blog" },
//       { name: "Events", path: "/events" },
//       { name: "About Us", path: "/about" },
//     ],
//     programs: [
//       {
//         name: "Computer Science and Engineering",
//         path: "/courses",
//         state: { courseId: "cs101" },
//       },

//     ],
//     support: [{ name: "Contact Us", path: "/contact" }],
//   };

//   const contactInfo = [
//     {
//       icon: HiLocationMarker,
//       text: "123 Education Street, Knowledge City, KC 12345",
//       subtext: "Visit our campus",
//     },
//     {
//       icon: HiPhone,
//       text: "+1 (555) 123-4567",
//       subtext: "Mon-Fri 9am-6pm",
//     },
//   ];

//   const socialLinks = [
//     { icon: FaFacebookF, url: "#", color: "hover:text-blue-600" },
//     { icon: FaTwitter, url: "#", color: "hover:text-blue-400" },
//     { icon: FaInstagram, url: "#", color: "hover:text-pink-600" },
//     { icon: FaLinkedinIn, url: "#", color: "hover:text-blue-700" },
//     { icon: FaYoutube, url: "#", color: "hover:text-red-600" },
//   ];

//   return (
//     <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white tracking-wide">
//       {/* Main Footer */}
//       <div className="px-4 sm:px-6 lg:px-8 py-12">
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
//           {/* Brand & Contact */}
//           <motion.div
//             className="lg:col-span-1"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <div className="mb-6">
//               <img src={logo} alt="INSD Logo" className="h-16 w-auto mb-4" />
//             </div>

//             <div className="space-y-4">
//               {contactInfo.map((item, index) => (
//                 <motion.div
//                   key={index}
//                   className="flex items-start space-x-3 group cursor-pointer"
//                   whileHover={{ x: 5 }}
//                   transition={{ duration: 0.2 }}
//                 >
//                   <item.icon className="h-5 w-5 text-primaryColor group-hover:text-secondaryColor transition-colors duration-300" />
//                   <div>
//                     <p className="text-white font-medium group-hover:text-primaryColor transition-colors duration-300">
//                       {item.text}
//                     </p>
//                     <p className="text-gray-400 text-sm">{item.subtext}</p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </motion.div>

//           {/* Quick Links */}
//           <motion.div
//             className="hidden lg:block"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//           >
//             <h3 className="text-xl font-bold mb-6 text-primaryColor">
//               Quick Links
//             </h3>
//             <ul className="space-y-3">
//               {footerSections.quickLinks.map((link, index) => (
//                 <motion.li key={index} whileHover={{ x: 5 }}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group"
//                   >
//                     <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></span>
//                     {link.name}
//                   </Link>
//                 </motion.li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Programs */}
//           <motion.div
//             className="hidden lg:block"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//           >
//             <h3 className="text-xl font-bold mb-6 text-primaryColor">
//               Our Courses
//             </h3>
//             <ul className="space-y-3">
//               {footerSections.programs.map((link, index) => (
//                 <motion.li key={index} whileHover={{ x: 5 }}>
//                   <Link
//                     to={link.path}
//                     state={link.state}
//                     className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group"
//                   >
//                     <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></span>
//                     {link.name}
//                   </Link>
//                 </motion.li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Support & Social */}
//           <motion.div
//             className="hidden lg:block"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.3 }}
//           >
//             <h3 className="text-xl font-bold mb-6 text-primaryColor">Support</h3>
//             <ul className="space-y-3 mb-8">
//               {footerSections.support.map((link, index) => (
//                 <motion.li key={index} whileHover={{ x: 5 }}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group"
//                   >
//                     <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></span>
//                     {link.name}
//                   </Link>
//                 </motion.li>
//               ))}
//             </ul>

//             <div>
//               <h4 className="text-lg font-semibold mb-4 text-gray-300">
//                 Follow Us
//               </h4>
//               <div className="flex space-x-3">
//                 {socialLinks.map((social, index) => (
//                   <motion.a
//                     key={index}
//                     href={social.url}
//                     className="bg-gray-700 p-3 rounded-xl hover:bg-primaryColor transition-all duration-300 group"
//                     whileHover={{ scale: 1.1, y: -2 }}
//                     whileTap={{ scale: 0.95 }}
//                   >
//                     <social.icon
//                       className={`xl:h-5 xl:w-5 text-gray-300 ${social.color}`}
//                     />
//                   </motion.a>
//                 ))}
//               </div>
//             </div>
//           </motion.div>

//           {/* ✅ Mobile Accordion */}
//           <div className="lg:hidden space-y-4">
//             {/* Mobile Programs */}
//             <motion.div className="bg-gray-800 rounded-2xl overflow-hidden">
//               <button
//                 onClick={() => toggleSection("programs")}
//                 className="w-full px-6 py-4 flex justify-between items-center bg-gray-800 hover:bg-gray-750 transition-colors duration-300"
//               >
//                 <span className="text-lg font-semibold text-primaryColor">
//                   Our Programs
//                 </span>
//                 <motion.div
//                   animate={{ rotate: openSection === "programs" ? 180 : 0 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <HiChevronDown className="h-5 w-5 text-gray-400" />
//                 </motion.div>
//               </button>
//               <AnimatePresence>
//                 {openSection === "programs" && (
//                   <motion.div
//                     initial={{ height: 0, opacity: 0 }}
//                     animate={{ height: "auto", opacity: 1 }}
//                     exit={{ height: 0, opacity: 0 }}
//                     transition={{ duration: 0.3 }}
//                     className="overflow-hidden"
//                   >
//                     <div className="px-6 py-4 bg-gray-850">
//                       <ul className="space-y-3">
//                         {footerSections.programs.map((link, index) => (
//                           <li key={index}>
//                             <Link
//                               to={link.path}
//                               state={link.state}
//                               className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center py-2"
//                             >
//                               <span className="w-2 h-2 bg-secondaryColor rounded-full mr-3"></span>
//                               {link.name}
//                             </Link>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </motion.div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Bar */}
//       <motion.div
//         className="border-t border-gray-700"
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         transition={{ duration: 0.5 }}
//       >
//         <div className="px-4 sm:px-6 lg:px-8 py-6">
//           <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
//             <p className="text-gray-400 text-sm text-center md:text-left">
//               © {currentYear} INSD Institute. All rights reserved.
//             </p>
//             <div className="text-gray-400 text-sm text-center">
//               Designed & Developed by{" "}
//               <a
//                 href="https://www.webbocket.com"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="text-white hover:text-primaryColor transition-colors duration-300 font-medium"
//               >
//                 WebBocket Pvt. Ltd.
//               </a>
//             </div>
//           </div>
//         </div>
//       </motion.div>

//       {/* Back to Top */}
//       <motion.button
//         className="fixed bottom-8 right-8 bg-primaryColor hover:bg-secondaryColor text-white p-3 rounded-full shadow-lg z-50"
//         whileHover={{ scale: 1.1, y: -2 }}
//         whileTap={{ scale: 0.9 }}
//         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//       >
//         <HiChevronUp className="h-6 w-6" />
//       </motion.button>
//     </footer>
//   );
// };

// export default UserFooter;

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  HiPhone,
  HiLocationMarker,
  HiChevronDown,
  HiChevronRight,
} from "react-icons/hi";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import logo from "../../Assets/Logos/insd-logo.png";
import ugc from "../../Assets/ugc.webp";

const UserFooter = () => {
  const [openSection, setOpenSection] = useState(null);

  // Regular courses
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  // Upcoming courses
  const [upcomingCourses, setUpcomingCourses] = useState([]);
  const [upcomingLoading, setUpcomingLoading] = useState(true);

  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  // ============================================================
  // FETCH REGULAR COURSES
  // ============================================================
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/courses/get-all`,
        );

        if (response.data.success) {
          const apiCourses = response.data.data.map((course) => ({
            ...course,
            isStatic: false,
          }));

          setCourses(apiCourses);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  // ============================================================
  // FETCH UPCOMING COURSES
  // ============================================================
  useEffect(() => {
    const fetchUpcomingCourses = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/upcoming-courses/active`,
        );

        if (response.data.success) {
          setUpcomingCourses(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching upcoming courses:", error);
        setUpcomingCourses([]);
      } finally {
        setUpcomingLoading(false);
      }
    };

    fetchUpcomingCourses();
  }, []);

  // ============================================================
  // SLUGIFY
  // ============================================================
  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-");

  // ============================================================
  // TOGGLE MOBILE SECTIONS
  // ============================================================
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  // ============================================================
  // REGULAR COURSE NAVIGATION
  // ============================================================
  const handleCourseNavigation = (course) => {
    navigate(`/courses/${slugify(course.category)}`, {
      state: {
        courseId: course._id,
      },
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setOpenSection(null);
  };

  // ============================================================
  // UPCOMING COURSE NAVIGATION
  // ============================================================
  const handleUpcomingCourseNavigation = (course) => {
    navigate(`/upcoming-courses/${slugify(course.name)}`, {
      state: {
        courseId: course._id,
        courseName: course.name,
      },
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setOpenSection(null);
  };

  // ============================================================
  // FOOTER SECTIONS
  // ============================================================
  const footerSections = {
    quickLinks: [
      {
        name: "Gallery",
        path: "/gallery",
      },
      {
        name: "Blog & News",
        path: "/blog",
      },
      {
        name: "Events",
        path: "/events",
      },
      {
        name: "About Us",
        path: "/about",
      },
      {
        name: "Privacy-Policy",
        path: "/privacy-policy",
      },
    ],

    support: [
      {
        name: "Contact Us",
        path: "/contact",
      },
    ],
  };

  // ============================================================
  // CONTACT INFORMATION
  // ============================================================
  const contactInfo = [
    {
      icon: HiLocationMarker,
      text: "3rd Floor, C/o-Hdfc bank, Biju Pattnaik College Rd, Jayadev Vihar, Bhubaneswar, Odisha 751013",
      subtext: "",
    },
    {
      icon: HiPhone,
      text: "7205648333",
      subtext: "Mon-Sat 10am-6pm",
    },
  ];

  // ============================================================
  // SOCIAL LINKS
  // ============================================================
  const socialLinks = [
    {
      icon: FaFacebookF,
      url: "https://www.facebook.com/Insd.Bhubaneswar",
      color: "hover:text-blue-600",
    },
    {
      icon: FaInstagram,
      url: "https://www.instagram.com/insd_bhubaneswar",
      color: "hover:text-blue-600",
    },
    {
      icon: FaLinkedinIn,
      url: "https://www.linkedin.com/in/insdbhubaneswar",
      color: "hover:text-blue-700",
    },
    {
      icon: FaYoutube,
      url: "https://www.youtube.com/@insdbhubaneswar",
      color: "hover:text-blue-600",
    },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white tracking-wide">
      {/* ============================================================
          MAIN FOOTER
      ============================================================ */}
      <div className="px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* ========================================================
              BRAND & CONTACT
          ======================================================== */}
          <motion.div
            className="lg:col-span-1"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mb-6">
              <img src={logo} alt="INSD Logo" className="h-16 w-auto mb-4" />
            </div>

            <div className="space-y-4">
              {contactInfo.map((item, index) => {
                const Icon = item.icon;

                return (
                  <motion.div
                    key={index}
                    className="flex items-start space-x-3 group cursor-pointer"
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <Icon className="h-5 w-5 text-primaryColor group-hover:text-secondaryColor transition-colors duration-300 flex-shrink-0" />

                    <div>
                      <p className="text-white font-medium group-hover:text-primaryColor transition-colors duration-300 sub-heading">
                        {item.text}
                      </p>

                      {item.subtext && (
                        <p className="text-gray-400 text-sm sub-heading">
                          {item.subtext}
                        </p>
                      )}
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          {/* ========================================================
              QUICK LINKS - DESKTOP
          ======================================================== */}
          <motion.div
            className="hidden lg:block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.1,
            }}
          >
            <h3 className="text-xl font-bold mb-6 text-primaryColor heading">
              Quick Links
            </h3>

            <ul className="space-y-3">
              {footerSections.quickLinks.map((link, index) => (
                <motion.li key={index} whileHover={{ x: 5 }}>
                  <Link
                    to={link.path}
                    onClick={() =>
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      })
                    }
                    className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group sub-heading"
                  >
                    <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></span>

                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* ========================================================
              COURSES - DESKTOP
          ======================================================== */}
          <motion.div
            className="hidden lg:block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.2,
            }}
          >
            <h3 className="text-xl font-bold mb-6 text-primaryColor heading">
              Our Courses
            </h3>

            <div className="max-h-72 overflow-y-auto pr-2 custom-scrollbar">
              {/* ----------------------------------------------------
                  REGULAR COURSES
              ---------------------------------------------------- */}
              {loading ? (
                <div className="text-gray-400 text-sm py-2">
                  Loading courses...
                </div>
              ) : courses.length > 0 ? (
                <ul className="space-y-3 sub-heading">
                  {courses.map((course) => (
                    <motion.li key={course._id} whileHover={{ x: 5 }}>
                      <button
                        onClick={() => handleCourseNavigation(course)}
                        className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group text-left w-full"
                      >
                        <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300 flex-shrink-0"></span>

                        <span className="text-sm">{course.category}</span>

                        <HiChevronRight className="h-4 w-4 ml-auto text-gray-500 group-hover:text-primaryColor transition-colors duration-300 flex-shrink-0" />
                      </button>
                    </motion.li>
                  ))}
                </ul>
              ) : (
                <div className="text-gray-400 text-sm py-2">
                  No courses available
                </div>
              )}

              {/* ----------------------------------------------------
                  UPCOMING COURSES
              ---------------------------------------------------- */}
              {upcomingLoading ? (
                <div className="text-gray-400 text-sm py-3">
                  Loading upcoming courses...
                </div>
              ) : upcomingCourses.length > 0 ? (
                <div className=" pt-4 border-gray-700">
                  <ul className="space-y-3 sub-heading">
                    {upcomingCourses.map((course) => (
                      <motion.li key={course._id} whileHover={{ x: 5 }}>
                        <button
                          onClick={() => handleUpcomingCourseNavigation(course)}
                          className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group text-left w-full"
                        >
                          <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300 flex-shrink-0"></span>

                          <span className="text-sm">{course.name}</span>

                          <HiChevronRight className="h-4 w-4 ml-auto text-gray-500 group-hover:text-secondaryColor transition-colors duration-300 flex-shrink-0" />
                        </button>
                      </motion.li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </div>
          </motion.div>

          {/* ========================================================
              SUPPORT & SOCIAL - DESKTOP
          ======================================================== */}
          <motion.div
            className="hidden lg:block"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.5,
              delay: 0.3,
            }}
          >
            <h3 className="text-xl font-bold mb-6 text-primaryColor heading">
              Support
            </h3>

            <ul className="space-y-3 mb-8 sub-heading">
              {footerSections.support.map((link, index) => (
                <motion.li key={index} whileHover={{ x: 5 }}>
                  <Link
                    to={link.path}
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center group"
                  >
                    <span className="w-2 h-2 bg-primaryColor rounded-full mr-3 group-hover:scale-125 transition-transform duration-300"></span>

                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>

            {/* Mobile Social Links */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold mb-4 text-gray-300">
                Follow Us
              </h4>

              <div className="flex space-x-3">
                {socialLinks.map((social, index) => {
                  const SocialIcon = social.icon;

                  return (
                    <motion.a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gray-700 p-3 rounded-xl hover:bg-primaryColor transition-all duration-300"
                      whileHover={{ scale: 1.1, y: -2 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <SocialIcon
                        className={`h-5 w-5 text-gray-300 ${social.color}`}
                      />
                    </motion.a>
                  );
                })}
              </div>

              {/* ADD THIS */}
              <img src={ugc} alt="UGC" className="h-32 w-auto mt-4" />
            </div>
          </motion.div>

          {/* ========================================================
              MOBILE ACCORDIONS
          ======================================================== */}
          <div className="lg:hidden space-y-4">
            {/* ======================================================
                MOBILE QUICK LINKS
            ====================================================== */}
            <motion.div className="bg-gray-800 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleSection("quickLinks")}
                className="w-full px-6 py-4 flex justify-between items-center bg-gray-800 hover:bg-gray-750 transition-colors duration-300"
              >
                <span className="text-lg font-semibold text-primaryColor heading">
                  Quick Links
                </span>

                <motion.div
                  animate={{
                    rotate: openSection === "quickLinks" ? 180 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <HiChevronDown className="h-5 w-5 text-gray-400" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openSection === "quickLinks" && (
                  <motion.div
                    initial={{
                      height: 0,
                      opacity: 0,
                    }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                    }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 py-4 bg-gray-850">
                      <ul className="space-y-3">
                        {footerSections.quickLinks.map((link, index) => (
                          <li key={index}>
                            <Link
                              to={link.path}
                              onClick={() => {
                                window.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });
                                setOpenSection(null);
                              }}
                              className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center py-2 sub-heading"
                            >
                              <span className="w-2 h-2 bg-secondaryColor rounded-full mr-3"></span>

                              {link.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>

            {/* ======================================================
                MOBILE COURSES
            ====================================================== */}
            <motion.div className="bg-gray-800 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleSection("courses")}
                className="w-full px-6 py-4 flex justify-between items-center bg-gray-800 hover:bg-gray-750 transition-colors duration-300"
              >
                <span className="text-lg font-semibold text-primaryColor heading">
                  Our Courses
                </span>

                <motion.div
                  animate={{
                    rotate: openSection === "courses" ? 180 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <HiChevronDown className="h-5 w-5 text-gray-400" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openSection === "courses" && (
                  <motion.div
                    initial={{
                      height: 0,
                      opacity: 0,
                    }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                    }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 py-4 bg-gray-850 max-h-96 overflow-y-auto custom-scrollbar">
                      {/* ------------------------------------------------
                          MOBILE REGULAR COURSES
                      ------------------------------------------------ */}
                      {loading ? (
                        <div className="text-gray-400 text-sm py-2">
                          Loading courses...
                        </div>
                      ) : courses.length > 0 ? (
                        <ul className="space-y-3 sub-heading">
                          {courses.map((course) => (
                            <li key={course._id}>
                              <button
                                onClick={() => handleCourseNavigation(course)}
                                className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center py-2 text-left w-full group"
                              >
                                <span className="w-2 h-2 bg-secondaryColor rounded-full mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-300"></span>

                                <span className="text-sm">
                                  {course.category}
                                </span>

                                <HiChevronRight className="h-4 w-4 ml-auto text-gray-500 group-hover:text-secondaryColor flex-shrink-0" />
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="text-gray-400 text-sm py-2">
                          No courses available
                        </div>
                      )}

                      {/* ------------------------------------------------
                          MOBILE UPCOMING COURSES
                      ------------------------------------------------ */}
                      {upcomingLoading ? (
                        <div className="text-gray-400 text-sm py-3">
                          Loading upcoming courses...
                        </div>
                      ) : upcomingCourses.length > 0 ? (
                        <div className="mt-4 pt-4 border-t border-gray-700">
                          <ul className="space-y-3 sub-heading">
                            {upcomingCourses.map((course) => (
                              <li key={course._id}>
                                <button
                                  onClick={() =>
                                    handleUpcomingCourseNavigation(course)
                                  }
                                  className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center py-2 text-left w-full group"
                                >
                                  <span className="w-2 h-2 bg-secondaryColor rounded-full mr-3 flex-shrink-0 group-hover:scale-125 transition-transform duration-300"></span>

                                  <span className="text-sm">{course.name}</span>

                                  <HiChevronRight className="h-4 w-4 ml-auto text-gray-500 group-hover:text-secondaryColor flex-shrink-0" />
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>

            {/* ======================================================
                MOBILE SUPPORT
            ====================================================== */}
            <motion.div className="bg-gray-800 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleSection("support")}
                className="w-full px-6 py-4 flex justify-between items-center bg-gray-800 hover:bg-gray-750 transition-colors duration-300"
              >
                <span className="text-lg font-semibold text-primaryColor heading">
                  Support
                </span>

                <motion.div
                  animate={{
                    rotate: openSection === "support" ? 180 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <HiChevronDown className="h-5 w-5 text-gray-400" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openSection === "support" && (
                  <motion.div
                    initial={{
                      height: 0,
                      opacity: 0,
                    }}
                    animate={{
                      height: "auto",
                      opacity: 1,
                    }}
                    exit={{
                      height: 0,
                      opacity: 0,
                    }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 py-4 bg-gray-850 sub-heading">
                      <ul className="space-y-3">
                        {footerSections.support.map((link, index) => (
                          <li key={index}>
                            <Link
                              to={link.path}
                              onClick={() => {
                                window.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });
                                setOpenSection(null);
                              }}
                              className="text-gray-300 hover:text-white transition-colors duration-300 flex items-center py-2"
                            >
                              <span className="w-2 h-2 bg-secondaryColor rounded-full mr-3"></span>

                              {link.name}
                            </Link>
                          </li>
                        ))}
                      </ul>

                      {/* Mobile Social Links */}
                      {/* Mobile Social Links */}
                      <div className="mt-6">
                        <h4 className="text-lg font-semibold mb-4 text-gray-300">
                          Follow Us
                        </h4>

                        <div className="flex space-x-3">
                          {socialLinks.map((social, index) => {
                            const SocialIcon = social.icon;

                            return (
                              <motion.a
                                key={index}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-gray-700 p-3 rounded-xl hover:bg-primaryColor transition-all duration-300"
                                whileHover={{ scale: 1.1, y: -2 }}
                                whileTap={{ scale: 0.95 }}
                              >
                                <SocialIcon
                                  className={`h-5 w-5 text-gray-300 ${social.color}`}
                                />
                              </motion.a>
                            );
                          })}
                        </div>

                        {/* ADD THIS */}
                        <img src={ugc} alt="UGC" className="h-24 w-auto mt-4" />
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          </div>
        </div>
      </div>

      {/* ============================================================
          BOTTOM BAR
      ============================================================ */}
      <motion.div
        className="border-t border-gray-700"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} INSD Institute. All rights reserved.
            </p>

            <div className="text-gray-400 text-sm text-center">
              Designed & Developed by{" "}
              <a
                href="https://www.webbocket.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-primaryColor transition-colors duration-300 font-medium"
              >
                WebBocket Pvt. Ltd.
              </a>
            </div>
          </div>
        </div>
      </motion.div>

      {/* ============================================================
          CUSTOM SCROLLBAR STYLES
      ============================================================ */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.5);
        }
      `}</style>
    </footer>
  );
};

export default UserFooter;
